import { useState } from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { AuthAction } from 'src/actions/auth.action';

import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';

import Logo from './Logo';
import { emitter } from 'src/utils/emitter';

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const { leaders, brands, info, role } = useSelector(state => state.profile)
  const [notifications] = useState([]);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(AuthAction.logout())
  }
  
  const addTab = (component = null) => {
    if (component != null) {
      emitter.emit("add_tab", component)
    }
  }

  return (
    <AppBar
      elevation={0}
      {...rest}
    >
      <Toolbar className='flex-container' style={{ background: role.priority < 3 ? 'inherit' : '#237BD3', minHeight: 0 }}>
        {/* <RouterLink to="/"> */}
          <Logo />
        {/* </RouterLink> */}

        {/* MENU_CUSTOM */}
        <Hidden lgDown>
          <IconButton color="inherit" onClick={onMobileNavOpen} size="large">
            <MenuIcon />
          </IconButton>
        </Hidden>

        <Box className='web-title' sx={{ flexGrow: 1 }}
          display='flex'
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="h3">
            Hệ thống sim số
          </Typography>
        </Box>
        <Box className='flex-item-right'>
          <IconButton color="inherit" size="large">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton color="inherit" size="large" onClick={handleLogout}>
            <InputIcon />
          </IconButton>
          <Hidden lgUp>
            <IconButton color="inherit" onClick={onMobileNavOpen} size="large">
              <MenuIcon />
            </IconButton>
          </Hidden>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
